//  YAxisProps.tsx
import React from 'react';
import AxisProps from './AxisOptions';
import {
  ChartConAxisOptions,
  ChartConYAxis,
} from '../../../../redux/ChartPoperties/ChartControlsInterface';

const axisOptionsForY = [
  { type: 'Left', value: 'left' },
  { type: 'Right', value: 'right' },
  { type: 'Hide', value: 'hide' },
];

const positions = [
  { name: 'Start', value: 'start' },
  { name: 'Middle', value: 'middle' },
  { name: 'End', value: 'end' },
];

interface YAxisPropsComponentProps {
  propKey: string;
  chartType: string;
  property: ChartConAxisOptions & {
    scatterChartMinMax: {
      y_enableMin: boolean;
      y_minValue: number;
      y_enableMax: boolean;
      y_maxValue: number;
    };
    ySplitLine: boolean;
  };
  yAxisProps: ChartConYAxis;
  updateAxisOptions: (axis: string, option: string, value: any) => void;
  updateAxisMinMaxforScatter: (axisKey: string, value: any) => void;
  enableGrids: (propKey: string, option: string, value: any) => void;
  iconColor?: string;
  backgroundColor?: string;
}

const YAxisProps: React.FC<YAxisPropsComponentProps> = ({
  propKey,
  chartType,
  property,
  yAxisProps,
  updateAxisOptions,
  updateAxisMinMaxforScatter,
  enableGrids,
  iconColor,
  backgroundColor,
}) => {
  return (
    //renders the component from AxisOptions.tsx, for change in component refer to AxisOptions.tsx
    <AxisProps
      propKey={propKey}
      chartType={chartType}
      axisType="y"
      property={property}
      axisProps={yAxisProps}
      updateAxisOptions={updateAxisOptions}
      updateAxisMinMaxforScatter={updateAxisMinMaxforScatter}
      enableGrids={enableGrids}
      positions={positions}
      axisOptions={axisOptionsForY}
      iconColor={iconColor}
      backgroundColor={backgroundColor}
    />
  );
};

export default YAxisProps;
